//SocialPosts.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ClipLoader } from 'react-spinners';
import { FiCopy, FiTwitter, FiLinkedin } from 'react-icons/fi';
import { FiClipboard } from "react-icons/fi"; // Example icon, you can choose another icon

const SocialPosts = ({ draftId }) => {
    const [linkedinPosts, setLinkedinPosts] = useState([]);
    const [twitterPosts, setTwitterPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('LinkedIn'); // Active tab state

    useEffect(() => {
      const fetchSocialPosts = async () => {
        setIsLoading(true);
        setError(null);
        try {
          const response = await axios.post(`https://trendhopper-c3934b7293e6.herokuapp.com/social-posts/${draftId}/`);
          console.log('the response', response);
          setLinkedinPosts(response.data.linkedin_posts);
          setTwitterPosts(response.data.twitter_posts);
        } catch (err) {
          setError('Failed to fetch social media posts');
        } finally {
          setIsLoading(false);
        }
      };

      fetchSocialPosts();
    }, [draftId]);

    const handleCopy = (text) => {
      navigator.clipboard.writeText(text); // Copy the text to clipboard
    };

    return (
      <div className="h-full space-y-4 bg-white p-4"> {/* h-full added */}
        <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          <FiClipboard className="text-blue-500" /> {/* Icon next to the title */}
          Social Media Post Ideas
        </h2>

        {/* Tabs */}
        <div className="flex space-x-2">
          <button
            onClick={() => setActiveTab('LinkedIn')}
            className={`px-4 py-2 rounded-lg ${activeTab === 'LinkedIn'
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors'}`}
          >
            <FiLinkedin className="inline-block mr-2" />
            LinkedIn
          </button>
          <button
            onClick={() => setActiveTab('Twitter')}
            className={`px-4 py-2 rounded-lg ${activeTab === 'Twitter'
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors'}`}
          >
            <FiTwitter className="inline-block mr-2" />
            Twitter
          </button>
        </div>

        {isLoading ? (
          <ClipLoader color="#36D7B7" size={20} />
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div className="mt-4 overflow-y-auto"> {/* Set a max height for scrollable content */}
            <div>
              {activeTab === 'LinkedIn' && (
                <div className="space-y-2">
                  {linkedinPosts.map((post, index) => (
                    <div key={index} className="border border-gray-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all bg-white">
                      <p className="text-gray-700 leading-relaxed">{post}</p> {/* Style like a LinkedIn post */}
                      <div className="flex justify-end mt-2">
                        <button onClick={() => handleCopy(post)} className="text-blue-500 hover:text-blue-700">
                          <span className="mr-2">Copy</span>
                          <FiCopy className="inline-block" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === 'Twitter' && (
                <div className="space-y-2">
                  {twitterPosts.map((post, index) => (
                    <div key={index} className="border border-gray-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all bg-white">
                      <p className="text-gray-700 leading-snug">{post}</p> {/* Style like a tweet */}
                      <div className="flex justify-end mt-2">
                        <button onClick={() => handleCopy(post)} className="text-blue-500 hover:text-blue-700">
                          <span className="mr-2">Copy</span>
                          <FiCopy className="inline-block" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  export default SocialPosts;
